module.exports = __webpack_public_path__ + "static/media/Banner_Conheça o Nosso Curso.fe66b807.png";